import { Link } from 'react-router-dom';
import { MapPin, Bed, Bath, Square } from 'lucide-react';
import { fixImageUrl } from '../utils/imageUtils';

export const PropertyCard = ({ property }) => {
  const getStatusStyle = (status) => {
    switch (status) {
      case 'Vendu':
        return 'bg-red-500 text-white';
      case 'Sous option':
        return 'bg-amber-500 text-white';
      default:
        return 'bg-green-500 text-white';
    }
  };

  const imageUrl = fixImageUrl(property.images?.[0]) || 'https://images.unsplash.com/photo-1520608421741-68228b76b6df';

  return (
    <Link 
      to={`/properties/${property.id}`} 
      data-testid={`property-card-${property.id}`}
      className="property-card group block bg-white border border-border/40 overflow-hidden hover:shadow-xl transition-all duration-500"
    >
      <div className="overflow-hidden relative">
        <img
          src={imageUrl}
          alt={property.title}
          className="property-card-image w-full"
        />
        {property.status && property.status !== 'À vendre' && (
          <div className={`absolute top-4 left-4 px-3 py-1 text-xs uppercase tracking-widest font-semibold ${getStatusStyle(property.status)}`}>
            {property.status}
          </div>
        )}
      </div>
      <div className="p-6 space-y-4">
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-muted-foreground font-semibold">
            <MapPin className="w-3 h-3" />
            {property.location}
          </div>
          <h3 data-testid="property-title" className="text-2xl font-serif tracking-tight">{property.title}</h3>
        </div>
        
        <div className="flex items-center gap-4 text-sm text-muted-foreground">
          <div className="flex items-center gap-1">
            <Bed className="w-4 h-4" />
            {property.bedrooms}
          </div>
          <div className="flex items-center gap-1">
            <Bath className="w-4 h-4" />
            {property.bathrooms}
          </div>
          <div className="flex items-center gap-1">
            <Square className="w-4 h-4" />
            {property.surface}m²
          </div>
        </div>

        <div className="pt-4 border-t border-border flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-widest text-muted-foreground">Prix</div>
            <div data-testid="property-price" className="text-2xl font-serif font-bold text-accent">€{property.price.toLocaleString()}</div>
          </div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold group-hover:translate-x-2 transition-transform duration-300">
            Voir plus →
          </div>
        </div>
      </div>
    </Link>
  );
};